module.exports = __webpack_public_path__ + "img/coolwalletpro.26918a79.svg";